import { subscriptionCurrencyFromCountryCode } from './region.service';

const planCurrencyPrices: {
  currency: string;
  currencyString: string;
  month: number;
  year: number;
}[] = [
  // USD is default, leave here
  {
    currency: 'usd',
    currencyString: 'US$',
    month: 25,
    year: 250,
  },
  {
    currency: 'aud',
    currencyString: 'AU$',
    month: 30,
    year: 300,
  },
  {
    currency: 'eur',
    currencyString: '€',
    month: 20,
    year: 200,
  },
  {
    currency: 'gbp',
    currencyString: '£',
    month: 20,
    year: 200,
  },
  {
    currency: 'nzd',
    currencyString: 'NZ$',
    month: 33,
    year: 330,
  },
  {
    currency: 'cad',
    currencyString: 'CA$',
    month: 27,
    year: 270,
  },
  {
    currency: 'jpy',
    currencyString: '¥',
    month: 3000,
    year: 30000,
  },
  {
    currency: 'twd',
    currencyString: 'NT$',
    month: 650,
    year: 6500,
  },
];

export function getPlanPrice(alpha3: string) {
  const currency = subscriptionCurrencyFromCountryCode(alpha3);

  return (
    planCurrencyPrices.find((p) => p.currency === currency) ??
    planCurrencyPrices[0]
  );
}

export function stripeAmountToString({
  currency,
  amount,
}: {
  currency: string;
  amount: number;
}) {
  // Japan is a zero decimal currency
  let amountString = amount.toString();
  if (currency !== 'jpy') {
    amountString =
      amountString.slice(0, amountString.length - 2) +
      '.' +
      amountString.slice(amountString.length - 2);
  }
  const plan = planCurrencyPrices.find((p) => p.currency === currency);
  if (plan) amountString = plan.currencyString + amountString;
  return amountString;
}
